import { isFunction } from 'rxjs/util/isFunction';
import { isPlatformServer } from '@angular/common';
import { Component, Input, OnInit, ElementRef, AfterViewChecked, AfterViewInit, ChangeDetectorRef, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { LazyViewport, LazyTarget } from 'angular-shared-features/feature/custom-image/lazy/lazy-viewport';

@Component({
    selector: 'on-screen',
    template: `<ng-content *ngIf="isVisible"></ng-content>`,
    styles: [':host {display: block;}', ':host > div {width: 100%;height: 100%;}']
})
export class OnScreenComponent implements LazyTarget {
    // add all the options as optional settings and use them to create an options object
    public isVisible:boolean = false;
    public element: Element;

    constructor(protected cd:ChangeDetectorRef, 
        protected lazyViewport:LazyViewport,
        elementRef: ElementRef) {
            this.element = elementRef.nativeElement;
        }

    ngOnDestroy(){
        ( this.lazyViewport ) && this.lazyViewport.removeTarget( this );
        this.lazyViewport = null;
    }

    public ngOnInit() : void {

        // Attached this directive the LazyViewport so that we can be alerted to changes
        // in this element's visibility on the page.
        this.lazyViewport.addTarget( this );

    }

    public ngOnChanges() : void {
        ( this.lazyViewport ) && this.lazyViewport.removeTarget( this );
        this.lazyViewport.addTarget( this );
    }

    public updateVisibility( isVisible: boolean, ratio: number ) : void {
        this.isVisible = isVisible;
        this.cd.detectChanges();
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-component/on-screen/on-screen.component.ts